import Vue from "vue";
import App from "./App.vue";
import moment from 'moment';
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueHead from 'vue-head';
import VueMeta from 'vue-meta';
import VueSession from 'vue-session';
import VueCookies from 'vue-cookies';
import VueAnalytics from 'vue-analytics';
import VueYoutube from 'vue-youtube';
import "@babel/polyfill";
import './common/filters';

// import Router     from 'vue-router';
// import { routes } from './router/index.js';
// Vue.use(Router);


Vue.config.productionTip = false;

Vue.use(VueSession);

import axios from 'axios';
axios.interceptors.response.use(
  response => response,
);

axios.interceptors.request.use(
  config => {
    if (store.state.jwt_auth_token) {
      config.headers.Authorization = 'JWT '+store.state.jwt_auth_token
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

Vue.prototype.$api = axios;
Vue.prototype.moment = moment;

Vue.prototype.$diagonal= {
  bottom: 'bottom',
  top: 'top',
}

Vue.use(VueHead);
Vue.use(VueMeta, { refreshOnceOnNavigation: true});
Vue.use(VueSession);
Vue.use(VueCookies);
Vue.use(VueYoutube);

import AxiosPlugin from 'vue-axios-cors';
Vue.use(AxiosPlugin);

import { VueReCaptcha } from 'vue-recaptcha-v3';
Vue.use(VueReCaptcha, {
  siteKey: '6LePY-gUAAAAADhnJKmwhW9PSdm7vY7adfIQ8S4V',
  loaderOptions: {
    autoHideBadge: true,
    useRecaptchaNet: true
  }
});

// Configuration VueAnalytics
Vue.use(VueAnalytics, {
  // id: 'UA-121215113-1',
  // id: 'G-MX7W9E8S79',
  id: '310084373',
  router
});

new Vue({
  router,
  store,
  vuetify,
  VueSession,
  render: h => h(App)
}).$mount("#app");
